import styled from 'styles/styled';

// eslint-disable-next-line import/prefer-default-export
export const LoaderWrapper = styled.div`
  padding-top: 20vh;
`;
